import type { LoadBalancer, LbListener } from '@/api/opennebula';

/** Pick the LB's primary network nic for the update payload (public, else first). */
export function primaryNic(lb: LoadBalancer) {
  const nics = lb.metadata?.nics ?? [];
  return nics.find((n) => /public/i.test(n.network ?? '')) ?? nics[0];
}

/**
 * Assign the @console-style names the backend needs to build HAProxy context
 * keys: listeners → `LB<n>` (kept if already valid, otherwise max existing + 1),
 * servers → `SERVER<index>` (re-indexed per save — the backend rewrites every
 * `ONEAPP_VNF_HAPROXY_LB*` key on update, so positional names are safe). Without
 * these the keys come out malformed, e.g. `ONEAPP_VNF_HAPROXY__IP` /
 * `ONEAPP_VNF_HAPROXY___HOST`, and the listener never takes effect.
 */
export function withNames(listeners: LbListener[]): LbListener[] {
  let maxLb = listeners.reduce((m, l) => {
    const n = /^LB(\d+)$/.exec(l.name ?? '')?.[1];
    return n ? Math.max(m, Number(n)) : m;
  }, 0);
  return listeners.map((l) => ({
    ...l,
    name: /^LB\d+$/.test(l.name ?? '') ? l.name : `LB${(maxLb += 1)}`,
    servers: (l.servers ?? []).map((s, j) => ({ ...s, name: `SERVER${j}` })),
  }));
}
